var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-box",
    [
      _c(
        "JadeGroupHeader",
        {
          scopedSlots: _vm._u([
            {
              key: "trailing",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "mt-1" },
                    [
                      _vm.loading
                        ? _c("JadeSpinner", { attrs: { size: "large" } })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(" " + _vm._s(_vm.$t("title")) + " ")]
      ),
      _vm.shouldDisplayEmptyState ? _c("EmptyState") : _vm._e(),
      !_vm.loading
        ? _vm._l(_vm.items, function (item, index) {
            return _c(
              "div",
              { key: `list-item-${index}` },
              [
                _c(
                  "router-link",
                  { key: index, attrs: { to: _vm.toLink(item.transactionId) } },
                  [
                    _c(
                      "jade-list-item",
                      {
                        attrs: {
                          label: item.chargeback.reasonDescription,
                          description: item.createdAt,
                          navigation: "",
                        },
                        on: {
                          onClick: function ($event) {
                            "javascript:void(0)"
                          },
                        },
                      },
                      [
                        _c("template", { slot: "trailing" }, [
                          _c(
                            "div",
                            { staticClass: "flex flex-col" },
                            [
                              _c("jade-text", [
                                _vm._v(
                                  " " +
                                    _vm._s(item.transactionalData.amount) +
                                    " "
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "mt-1 items-center flex gap-2" },
                                [
                                  _vm.showTooltipDeadline(item.status.code)
                                    ? _c(
                                        "jade-tooltip",
                                        {
                                          attrs: {
                                            placement: "top",
                                            text: _vm.$t(
                                              "deadline-expired-tooltip"
                                            ),
                                          },
                                        },
                                        [
                                          _c("jade-icon", {
                                            attrs: {
                                              use: "circle-info",
                                              size: "small",
                                              color: "negative",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "jade-tag",
                                    {
                                      attrs: {
                                        size: "medium",
                                        variant: _vm.statusBadge(
                                          item.status.code
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.status.label) + " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          })
        : _vm._e(),
      !_vm.shouldDisplayEmptyState
        ? _c("div", { staticClass: "mt-2" }, [_c("jade-divider")], 1)
        : _vm._e(),
      !_vm.shouldDisplayEmptyState
        ? _c(
            "div",
            { staticClass: "p-5 flex justify-end" },
            [
              _c("jade-pagination", {
                attrs: {
                  disabledPrevious: !_vm.hasPaginationPrevious || _vm.loading,
                  disabledNext: !_vm.hasPaginationNext || _vm.loading,
                },
                on: {
                  onPrevious: _vm.requestPrevious,
                  onNext: _vm.requestNext,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }